






export default {
  name: 'app'

  data: -> ready: false 

  mounted: ->
    setTimeout @makeReady, 200

  methods: 
    makeReady: -> @ready = true
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue